import { categories } from "@/mocks/homeData";
import SectionHeading from "@/components/base/SectionHeading";

export default function Collections() {
  return (
    <section id="collections" className="scroll-mt-24 bg-background-100 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="Curated Collections"
          title="精选写真合集分类"
          desc="按题材整理的六大方向，每个类别都有明确的拍摄手法与画面特征，方便你快速锁定喜欢的风格。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((category) => (
            <article
              key={category.id}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                  <i className={`${category.icon} text-xl`} />
                </span>
                <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
                  {category.count}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                {category.name}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                {category.desc}
              </p>
              <a
                href="#archive"
                className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
              >
                在珍藏库中查看
                <i className="ri-arrow-right-line" />
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}